import { motion } from 'framer-motion';

const CYCLE = 6;

const coverTimes = [0, 0.28, 0.33, 0.61, 0.66, 0.94, 1];
const coverTransition = { duration: CYCLE, repeat: Infinity, ease: 'easeInOut', times: coverTimes };

export default function CustomizeAnimation({ trigger }) {
  return (
    <svg viewBox="0 0 200 140" fill="none" className="w-full h-full">
      {/* Book spine */}
      <rect x="46" y="14" width="6" height="112" rx="2" fill="#B04040" />

      {/* Book cover — 3 color layers that crossfade */}
      <motion.rect
        x="52" y="14" width="80" height="112" rx="3" fill="#E86B63"
        animate={trigger ? { opacity: [1, 1, 0, 0, 0, 0, 1] } : { opacity: 1 }}
        transition={trigger ? coverTransition : {}}
      />
      <motion.rect
        x="52" y="14" width="80" height="112" rx="3" fill="#E8A84C"
        animate={trigger ? { opacity: [0, 0, 1, 1, 0, 0, 0] } : { opacity: 0 }}
        transition={trigger ? coverTransition : {}}
      />
      <motion.rect
        x="52" y="14" width="80" height="112" rx="3" fill="#3BA676"
        animate={trigger ? { opacity: [0, 0, 0, 0, 1, 1, 0] } : { opacity: 0 }}
        transition={trigger ? coverTransition : {}}
      />

      {/* Title lines on cover */}
      <rect x="64" y="38" width="52" height="5" rx="2.5" fill="white" opacity="0.9" />
      <rect x="68" y="48" width="40" height="4" rx="2" fill="white" opacity="0.6" />
      <rect x="64" y="57" width="48" height="4" rx="2" fill="white" opacity="0.6" />
      <rect x="72" y="66" width="32" height="4" rx="2" fill="white" opacity="0.5" />

      {/* Decorative dividers */}
      <line x1="64" y1="80" x2="120" y2="80" stroke="white" strokeWidth="0.5" opacity="0.3" />
      <line x1="64" y1="104" x2="120" y2="104" stroke="white" strokeWidth="0.5" opacity="0.3" />

      {/* Color swatches */}
      <circle cx="160" cy="44" r="9" fill="#FF6B81" />
      <circle cx="160" cy="70" r="9" fill="#FFB347" />
      <circle cx="160" cy="96" r="9" fill="#2FAF7F" />

      {/* Selection ring that cycles between swatches */}
      <motion.circle
        cx="160" cy="44" r="13" fill="none" stroke="#111" strokeWidth="2"
        animate={trigger ? { y: [0, 0, 26, 26, 52, 52, 0] } : { y: 0 }}
        transition={trigger ? coverTransition : {}}
      />
    </svg>
  );
}
